import { Doughnut } from 'vue-chartjs'
import { mapState } from 'vuex'
import { set } from 'lodash'
import { DEFAULT_PALETTE, DARK_DEFAULT_PALETTE } from '@/lib/colors.js'

export default {
  mixins: [Doughnut],
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    chartOptions: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.render()
  },
  computed: {
    ...mapState(['hideAmounts']),
  },
  watch: {
    hideAmounts() {
      this.render()
    },
  },
  methods: {
    render() {
      let myData, myOptions

      const nodata = this.chartData.datasets.every(
        (dataset) => dataset.data.length === 0 || dataset.data.every((item) => item === 0)
      )
      if (!nodata) {
        myData = { ...this.chartData }
        myOptions = { ...this.chartOptions }
      } else {
        myData = {
          datasets: [
            {
              data: [100],
              backgroundColor: [
                this.$vuetify.theme.dark ? 'rgba(41, 41, 41, 0.4)' : 'rgba(247, 248, 251, 0.7)',
              ],
              borderColor: this.$vuetify.theme.dark
                ? 'rgba(41, 41, 41, 0.4)'
                : 'rgba(247, 248, 251, 0.7)',
            },
          ],
          labels: [],
        }
        myOptions = {
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          tooltips: {
            enabled: false,
          },
          hover: { mode: null },
        }
      }

      set(
        myOptions,
        'legend.labels.fontColor',
        this.$vuetify.theme.dark ? DARK_DEFAULT_PALETTE.dark_Textgrey : DEFAULT_PALETTE.darkTextGrey
      )

      this.renderChart(myData, myOptions)
    },
  },
}
